class Tag {
  constructor(title, description, isSpecial, parentId) {
    this.title = title;
    this.description = description;
    this.isSpecial = isSpecial;
    this.parentId = parentId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      tagId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      tagManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'توضیحات', value: 'description', align: 'center' },
        { text: 'بالادستی', value: 'parent', align: 'center' },
        { text: 'ویژه', value: 'isSpecial', align: 'center' },
        { text: 'وضعیت', value: 'isActive', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      active: false,
      searchText: '',
      searchIsActive: 0,
      searchIsParent: 0,
      activeSearchItems: [
        { title: 'همه', id: 0 },
        { title: 'فعال', id: 1 },
        { title: 'غیر فعال', id: 2 },
      ],
      parentSearchItems: [
        { title: 'هیچ کدام', id: 0 },
        { title: 'هست', id: 1 },
        { title: 'نیست', id: 2 },
      ],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن برچسب';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش برچسب';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getTagFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.tag = new Tag('', '', false, null);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addTagFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش برچسب';
        this.$refs.confirm.text = 'از ویرایش برچسب اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف برچسب';
        this.$refs.confirm.text = 'از حذف برچسب اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addTagFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editTagFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteTagFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.tagId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfTagsWithPagination();
    },
    removeFilters: function () {
      this.searchIsActive = 0;
      this.searchIsParent = 0;
      this.searchText = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfTagsWithPagination();
    },
    cancelSearch: function () {
      this.searchIsActive = 0;
      this.searchIsParent = 0;
      this.searchText = '';
      this.searchModal = false;
    },
  },
};
